// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DefineStudyAreaInputArea } from "./DefineStudyAreaInputArea";
import {
  DefineStudyAreaInputAreaFromJSON,
  DefineStudyAreaInputAreaFromJSONTyped,
  DefineStudyAreaInputAreaToJSON,
  DefineStudyAreaInputAreaToJSONTyped,
} from "./DefineStudyAreaInputArea";

/**
 *
 * @export
 * @interface DefineStudyAreaInput
 */
export interface DefineStudyAreaInput {
  /**
   *
   */
  area: DefineStudyAreaInputArea;
  /**
   *
   */
  bufferMeters?: number;
}

/**
 * Check if a given object implements the DefineStudyAreaInput interface.
 */
export function instanceOfDefineStudyAreaInput(value: object): value is DefineStudyAreaInput {
  if (!("area" in value) || value["area"] === undefined) return false;
  return true;
}

export function DefineStudyAreaInputFromJSON(json: any): DefineStudyAreaInput {
  return DefineStudyAreaInputFromJSONTyped(json, false);
}

export function DefineStudyAreaInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DefineStudyAreaInput {
  if (json == null) {
    return json;
  }
  return {
    area: DefineStudyAreaInputAreaFromJSON(json["area"]),
    bufferMeters: json["buffer_meters"] == null ? undefined : json["buffer_meters"],
  };
}

export function DefineStudyAreaInputToJSON(json: any): DefineStudyAreaInput {
  return DefineStudyAreaInputToJSONTyped(json, false);
}

export function DefineStudyAreaInputToJSONTyped(
  value?: DefineStudyAreaInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    area: DefineStudyAreaInputAreaToJSON(value["area"]),
    buffer_meters: value["bufferMeters"],
  };
}
